import { message } from 'antd';

export const copyToClipboard = async (
  value: string | number | null | undefined
) => {
  if (value === null || value === undefined) return;
  try {
    await navigator.clipboard.writeText(value.toString());
    message.success('Скопировано');
  } catch {
    message.error('Ошибка копирования');
  }
};
